import React, { useEffect, useMemo, useState } from "react";
import { Form, Row, Col, FormGroup, Label, Input } from "reactstrap";
import { RELATIONSHIP_TYPE } from "../../../constants";
import { t } from "../../../utils/utils";
export default function LinkProperty({ link, linkChange }) {
  // el link tiene que estar previamente validado
  const properties = useMemo(
    () => ({
      fromModel: link.properties.secondAssociation[link.to.nodeId].target.model,
      toModel: link.properties.secondAssociation[link.to.nodeId].model
    }),
    [link]
  );
  //hooks del formulario
  const [fromRelation, setFromRelation] = useState("");
  const [toRelation, setToRelation] = useState("");
  useEffect(() => {
    setFromRelation(link.properties.connectionsProps.associationType);
    setToRelation(
      link.properties.secondAssociation[link.to.nodeId].target.associationType
    );
  }, [link]);
  const onChangeSelectFrom = e => {
    const { options } = e.target;
    const values = [].filter.call(options, o => o.selected).map(o => o.value);
    setFromRelation(values[0]);
  };

  const onChangeSelectTo = e => {
    const { options } = e.target;
    const values = [].filter.call(options, o => o.selected).map(o => o.value);
    setToRelation(values[0]);
  };
  const onSubmit = e => {
    e.preventDefault();
    const newLink = { ...link };
    newLink.properties.connectionsProps.associationType = fromRelation;
    newLink.properties.secondAssociation[
      newLink.to.nodeId
    ].target.associationType = toRelation;
    linkChange(newLink);
  };
  return (
    <>
      <Row>
        <Col md={8} className="offset-2">
          <Form id="formPropertyBar" onSubmit={onSubmit}>
            <FormGroup>
              <Label for="from">{`${t("nodoLink")} ${properties.fromModel} -> ${
                properties.toModel
              }`}</Label>
              <Input
                type="select"
                name="fromRelation"
                id="from"
                value={fromRelation}
                onChange={onChangeSelectFrom}
              >
                {RELATIONSHIP_TYPE.map((o, index) => (
                  <option key={index}>{o}</option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="to">{`${t("nodoLink")} ${properties.toModel} -> ${
                properties.fromModel
              }`}</Label>
              <Input
                type="select"
                name="toRelation"
                id="to"
                value={toRelation}
                onChange={onChangeSelectTo}
              >
                {RELATIONSHIP_TYPE.map((o, index) => (
                  <option key={index}>{o}</option>
                ))}
              </Input>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </>
  );
}
